import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import differenceInCalendarWeeksReal from 'date-fns/differenceInCalendarWeeks';
import endOfWeekReal from 'date-fns/endOfWeek';
import formatReal from 'date-fns/format';
import getWeekReal from 'date-fns/getWeek';
import isSameWeekReal from 'date-fns/isSameWeek';
import parseReal from 'date-fns/parse';
import setDayReal from 'date-fns/setDay';
import startOfWeekReal from 'date-fns/startOfWeek';
var DEFAULT_DATE_FNS_OPTIONS = {
  weekStartsOn: 1 // Start on monday. Week is monday -> sunday.
};

// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
var mixinDefaultOptions = function mixinDefaultOptions(fn) {
  return function () {
    var lastIndex = fn.length - 1;
    for (var _len = arguments.length, theArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      theArgs[_key] = arguments[_key];
    }
    if (fn.length === theArgs.length) {
      theArgs[lastIndex] = _objectSpread(_objectSpread({}, DEFAULT_DATE_FNS_OPTIONS), theArgs[lastIndex]);
    } else {
      theArgs[lastIndex] = DEFAULT_DATE_FNS_OPTIONS;
    }
    return fn.apply(this, theArgs);
  };
};
export var differenceInCalendarWeeks = mixinDefaultOptions(differenceInCalendarWeeksReal);
export var endOfWeek = mixinDefaultOptions(endOfWeekReal);
export var format = mixinDefaultOptions(formatReal);
export var getWeek = mixinDefaultOptions(getWeekReal);
export var isSameWeek = mixinDefaultOptions(isSameWeekReal);
export var parse = mixinDefaultOptions(parseReal);
export var setDay = mixinDefaultOptions(setDayReal);
export var startOfWeek = mixinDefaultOptions(startOfWeekReal);